import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ActiveModeCommands, Feature, IsStringValueProperty } from '@vi-iot/client';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-operating-mode-indicator',
  templateUrl: './operating-mode-indicator.component.html',
  styleUrls: ['./operating-mode-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatingModeIndicatorComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  @Input() operatingMode: Feature<IsStringValueProperty, ActiveModeCommands>;
  @Input() isDhw?: boolean;

  dhwOperatingModeName = 'dhw';
}
